import React, { useState, useRef, useEffect } from 'react';
import DemandLayer from './DemandLayer';
import { useUpdateEffect } from 'ahooks';
import { registerEventLayer } from '../events';
import useProps from '../_util/useProps';

export default function(props) {
    const {
        data,
        features,
        url,
        params,
        style,
        zIndex,
        id: key,
        _key,
        name,
        labelField,
        template,
        children,
        renderMode,
        show = true,
        method,
        legend,
        group,
    } = props;
    const [layerLoad, setLayerLoad] = useState(false);
    const layerRef = useRef();
    const { map, groupLayer } = useProps();

    useEffect(() => {
        let layer = new DemandLayer({
            url,
            data,
            renderMode,
            features,
            params,
            style,
            zIndex,
            key: key || _key,
            name,
            labelField,
            template,
            show,
            legend,
            group,
            map,
            groupLayer,
            method,
        });

        // 注册事件
        registerEventLayer(layer, props);

        setLayerLoad(true);

        if (groupLayer) {
            groupLayer.addLayer(layer);
        } else {
            map.addLayer(layer);
        }

        layerRef.current = layer;
        return () => {
            if (groupLayer) {
                groupLayer.removeLayer(layer);
            } else {
                map.removeLayer(layer);
            }
        };
    }, []);

    useUpdateEffect(() => {
        layerRef.current.loadData(data);
    }, [JSON.stringify(data)]);

    useUpdateEffect(() => {
        layerRef.current.setRenderMode(renderMode);
    }, [renderMode]);

    useUpdateEffect(() => {
        layerRef.current.show = show;
    }, [show]);

    useUpdateEffect(() => {
        layerRef.current.setGroup(group);
    }, [JSON.stringify(group)]);

    useUpdateEffect(() => {
        layerRef.current.loadUrlData(url, params, method);
    }, [url, method, JSON.stringify(params)]);

    return (
        <></>
    );
}
